import {
  TRIGGER_WEBHOOK,
  TRIGGER_WEBHOOK_SUCCESS,
  TRIGGER_WEBHOOK_ERROR,
  GET_SITE_VISIT_STATUS_DATA,
  UPDATE_SITE_VISIT_STATUS,
} from "../types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import siteVisitService from "../service/siteVisitService";

/**
 * Trigger webhook to send site visit status update to LMS
 * @param {Object} item - { jv_site_visit_id: string }
 */
export const triggerWebhook = (item) => async (dispatch) => {
  try {
    dispatch({
      type: TRIGGER_WEBHOOK,
      payload: { loading: true },
    });

    const res = await siteVisitService.triggerWebhook(item);
    
    if (res.data.status === 200 || res.data.status === "success") {
      dispatch({
        type: TRIGGER_WEBHOOK_SUCCESS,
        payload: res.data,
      });
      successToast(res.data.message || "Webhook triggered successfully");
      return res.data;
    } else {
      dispatch({
        type: TRIGGER_WEBHOOK_ERROR,
        payload: res.data.message || "Failed to trigger webhook",
      });
      errorToast(res.data.message || "Failed to trigger webhook");
      return null;
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    dispatch({
      type: TRIGGER_WEBHOOK_ERROR,
      payload: response.data?.message || "Error triggering webhook",
    });
    unAuthorizedError(response.data);
    errorToast(response.data?.message || "Error triggering webhook");
    return null;
  }
};

/**
 * Update site visit status and trigger webhook
 * @param {Object} item - { jv_site_visit_id, status, check_in_time, closing_status, marked_by }
 */
export const updateSiteVisitStatus = (item) => async (dispatch) => {
  try {
    const res = await siteVisitService.updateSiteVisitStatus(item);
    
    if (res.data.status === 200 || res.data.status === "success") {
      dispatch({
        type: UPDATE_SITE_VISIT_STATUS,
        payload: res.data,
      });
      // LMS update succeeded from backend's perspective
      successToast(res.data.message || "Site visit status sent to LMS successfully");
      return res.data;
    } else {
      // Backend processed the request but reported a failure (likely LMS error)
      errorToast(res.data.message || "Failed to send site visit status to LMS");
      return null;
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
    // Network/authorization/server error while trying to reach backend/LMS
    errorToast(response.data?.message || "Error sending site visit status to LMS");
    return null;
  }
};

/**
 * Get site visit status data
 * @param {Object} item - { jv_site_visit_id?, lms_site_visit_id?, appointment_id? }
 */
export const getSiteVisitStatusData = (item) => async (dispatch) => {
  try {
    const res = await siteVisitService.getSiteVisitStatusData(item);
    
    if (res.data.status === 200 || res.data.status === "success") {
      dispatch({
        type: GET_SITE_VISIT_STATUS_DATA,
        payload: res.data,
      });
      return res.data;
    } else {
      return null;
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
    return null;
  }
};